import { TagSchema, type ITag } from '@/validations/tag';

export function isITagArray(arr: unknown[]): arr is ITag[] {
  return arr.length === 0 || TagSchema.array().safeParse(arr).success;
}
